import { observer } from 'mobx-react-lite'
import React, { useEffect } from 'react'
import i from '../../../translations/i'
import { Titles } from '../../../layouts/Titles'
import { Row, Col, Input, Button } from 'antd'
import { FieldBlock } from '../../../components/SectionCard'
import controller, { SeoFileType } from './seoFiles.controller'

const FileEditor = observer(({ type, label, hint }: { type: SeoFileType, label: string, hint?: string }) => (
    <Col span={24}>
        <FieldBlock label={label}>
            <Input.TextArea
                rows={16}
                style={{ fontFamily: 'monospace' }}
                value={controller.files[type].content}
                onChange={e => controller.set(type, e.target.value)}
            />
            {hint && <div style={{ fontSize: 12, color: 'var(--text-muted-color)', marginTop: 6 }}>{hint}</div>}
            <div style={{ marginTop: 12 }}>
                <Button type="primary" onClick={() => controller.save(type)}>
                    {i.t('def:actions.save')}
                </Button>
            </div>
        </FieldBlock>
    </Col>
))

export const SeoFiles = observer(() => {
    useEffect(() => {
        controller.get()
    }, [])

    return (
        <>
            <Titles
                title={i.t('settings:seoFiles.title')}
                breadcrumb={[{ title: i.t('def:settings'), href: '/settings' }, { title: i.t('settings:seoFiles.title') }]}
            />

            {controller.render &&
                <Row gutter={[20, 20]}>
                    <FileEditor type="robots" label={i.t('settings:seoFiles.robots')} hint={i.t('settings:seoFiles.robotsHint')} />
                    <FileEditor type="sitemap" label={i.t('settings:seoFiles.sitemap')} hint={i.t('settings:seoFiles.sitemapHint')} />
                    <FileEditor type="llms" label={i.t('settings:seoFiles.llms')} hint={i.t('settings:seoFiles.llmsHint')} />
                </Row>
            }
        </>
    )
})
